module.exports = __webpack_public_path__ + "img/sofia-veciana.eb7e21f1.jpg";